import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { Language, MetricKey, NextPageKey, useOurAirports } from "../Corporate.hook";
import { toCamelCase, toPascalCase } from "../OurPolicies/OurPoliciesDynamic";
import { fields, fieldsReady } from "../constantsdum";
import { OurAirportsPageHeading } from "./OurAirportsPageHeading";

const convertDotNotation = (obj: any): any => {
  const result: any = {};
  for (const key in obj) {
    if (key === "image") {
      result[key] = obj[key];
      continue;
    }
    if (key.includes(".")) {
      const topLevelKey = key.split(".")[0];
      if (obj[topLevelKey] && typeof obj[topLevelKey] === "object") {
        continue;
      }

      const parts = key.split(".");
      let current = result;

      for (let i = 0; i < parts.length - 1; i++) {
        current[parts[i]] = current[parts[i]] || {};
        current = current[parts[i]];
      }

      current[parts[parts.length - 1]] = obj[key];
    } else {
      result[key] = obj[key];
    }
  }

  return result;
};

const filterNestedObjects = (obj: any): any => {
  const result: any = {};

  for (const key in obj) {
    if (key === "image") {
      result[key] = obj[key];
      continue;
    }
    if (typeof obj[key] === "object" && obj[key] !== null) {
      if (Array.isArray(obj[key])) {
        result[key] = obj[key];
      } else {
        result[key] = filterNestedObjects(obj[key]);
      }
    } else {
      result[key] = obj[key];
    }
  }

  return result;
};

// const convertDotNotation = (obj: any): any => {
//   const result: any = {};
//   for (const key in obj) {
//       if (key === 'image') {
//           result[key] = obj[key];
//           continue;
//       }

//       if (key.includes('.')) {
//           const parts = key.split('.');
//           let current = result;

//           for (let i = 0; i < parts.length - 1; i++) {
//               current[parts[i]] = current[parts[i]] || {};
//               current = current[parts[i]];
//           }

//           current[parts[parts.length - 1]] = obj[key];
//       } else {
//           result[key] = obj[key];
//       }
//   }
//   return result;
// };

// const filterNestedObjects = (obj: any): any => {
//   const result: any = {};

//   for (const key in obj) {
//       if (key === 'image') {
//           result[key] = obj[key];
//           continue;
//       }

//       if (Array.isArray(obj[key])) {
//           result[key] = obj[key].map((item: any) =>
//               typeof item === 'object' ? filterNestedObjects(item) : item
//           );
//       } else if (obj[key] !== null && typeof obj[key] === 'object') {
//           result[key] = filterNestedObjects(obj[key]);
//       } else {
//           result[key] = obj[key];
//       }
//   }

//   return result;
// };

const replacePayload = (target: any, source: any) => {
  for (const key in source) {
    if (source[key] instanceof Object && target[key]) {
      replacePayload(target[key], source[key]);
    } else {
      target[key] = source[key];
    }
  }
  // for (const key in source) {
  //     if (Array.isArray(source[key])) {
  //         target[key] = source[key];
  //     } else if (source[key] instanceof Object && target[key]) {
  //         replacePayload(target[key], source[key]);
  //     } else {
  //         target[key] = source[key];
  //     }
  // }
};

export const OurAirports: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();
  const [payloadData, setPayloadData] = useState<any>();

  const { data: airportsData, isLoading: isLoadingairports, refetch: refetchOurAirports } = useOurAirports();
  const {
    data: airportsDataById,
    isLoading: isLoadingairportsById,
    refetch: refetchAirportsById,
  } = useDocumentDetails(query?.get("id") || "");
  console.log("airportsData", airportsData, payloadData, airportsDataById);

  useEffect(() => {
    if (query?.get("id")) {
      setPayloadData(airportsDataById?.payload);
    } else {
      setPayloadData(airportsData?.[0]);
    }
  }, [airportsData, airportsDataById]);

  useEffect(() => {
    if (approveId) {
      return;
    }
    const thirdChildActiveTab = query.get("thirdSubActiveTab");
    if (query.get("activeTab") === "ourAirports" && query.get("subActiveTab") === "international") {
      navigate(
        `/dedicated/corporate/corporate-profile?activeTab=ourAirports&subActiveTab=international&thirdSubActiveTab=${
          thirdChildActiveTab ?? "klInternationalAirportForInternational_0"
        }`,
        {
          replace: true,
        }
      );
    }
    if (query.get("activeTab") === "ourAirports" && query.get("subActiveTab") === "domestic") {
      navigate(
        `/dedicated/corporate/corporate-profile?activeTab=ourAirports&subActiveTab=domestic&thirdSubActiveTab=${
          thirdChildActiveTab ?? "melakaAirportForDomestic_0"
        }`,
        {
          replace: true,
        }
      );
    }
    if (query.get("activeTab") === "ourAirports" && query.get("subActiveTab") === "stolports") {
      navigate(
        `/dedicated/corporate/corporate-profile?activeTab=ourAirports&subActiveTab=stolports&thirdSubActiveTab=${
          thirdChildActiveTab ?? "pangkorStolportForStolports_0"
        }`,
        {
          replace: true,
        }
      );
    }
    if (query.get("activeTab") === "ourAirports" && query.get("subActiveTab") === "overseas") {
      navigate(
        `/dedicated/corporate/corporate-profile?activeTab=ourAirports&subActiveTab=overseas&thirdSubActiveTab=${
          thirdChildActiveTab ?? "istanbulSabihaGokcenAirportForOverseas_0"
        }`,
        {
          replace: true,
        }
      );
    }
  }, [query.get("activeTab"), query.get("subActiveTab")]);
  useEffect(() => {
    if (approveId) {
      refetchAirportsById();
    } else {
      refetchOurAirports();
    }
  }, [query.get("subActiveTab"), query.get("thirdSubActiveTab"), approveId]);

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const NextPageFormConfig: FormConfig = {
    initialValues: {
      "field_content_english.data.nextPage.name": (() => {
        try {
          if (airportsDataById?.payload?.field_content_english) {
            const parsed = JSON.parse(airportsDataById.payload.field_content_english);
            return decodeHTML(parsed?.data?.nextPage?.name);
          }
          return decodeHTML(airportsData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
        } catch (error) {
          console.error("Error parsing English nextPage name:", error);
          return decodeHTML(airportsData?.[0]?.field_content_english?.data?.nextPage?.name) || "";
        }
      })(),

      "field_content_english.data.nextPage.link": (() => {
        try {
          if (airportsDataById?.payload?.field_content_english) {
            const parsed = JSON.parse(airportsDataById.payload.field_content_english);
            return decodeHTML(parsed?.data?.nextPage?.link);
          }
          return decodeHTML(airportsData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
        } catch (error) {
          console.error("Error parsing English nextPage link:", error);
          return decodeHTML(airportsData?.[0]?.field_content_english?.data?.nextPage?.link) || "";
        }
      })(),

      "field_content_malay.data.nextPage.name": (() => {
        try {
          if (airportsDataById?.payload?.field_content_malay) {
            const parsed = JSON.parse(airportsDataById.payload.field_content_malay);
            return decodeHTML(parsed?.data?.nextPage?.name);
          }
          return decodeHTML(airportsData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
        } catch (error) {
          console.error("Error parsing Malay nextPage name:", error);
          return decodeHTML(airportsData?.[0]?.field_content_malay?.data?.nextPage?.name) || "";
        }
      })(),

      "field_content_malay.data.nextPage.link": (() => {
        try {
          if (airportsDataById?.payload?.field_content_malay) {
            const parsed = JSON.parse(airportsDataById.payload.field_content_malay);
            return decodeHTML(parsed?.data?.nextPage?.link);
          }
          return decodeHTML(airportsData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
        } catch (error) {
          console.error("Error parsing Malay nextPage link:", error);
          return decodeHTML(airportsData?.[0]?.field_content_malay?.data?.nextPage?.link) || "";
        }
      })(),

      "field_content_mandarin.data.nextPage.name": (() => {
        try {
          if (airportsDataById?.payload?.field_content_mandarin) {
            const parsed = JSON.parse(airportsDataById.payload.field_content_mandarin);
            return decodeHTML(parsed?.data?.nextPage?.name);
          }
          return decodeHTML(airportsData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
        } catch (error) {
          console.error("Error parsing Mandarin nextPage name:", error);
          return decodeHTML(airportsData?.[0]?.field_content_mandarin?.data?.nextPage?.name) || "";
        }
      })(),

      "field_content_mandarin.data.nextPage.link": (() => {
        try {
          if (airportsDataById?.payload?.field_content_mandarin) {
            const parsed = JSON.parse(airportsDataById.payload.field_content_mandarin);
            return decodeHTML(parsed?.data?.nextPage?.link);
          }
          return decodeHTML(airportsData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
        } catch (error) {
          console.error("Error parsing Mandarin nextPage link:", error);
          return decodeHTML(airportsData?.[0]?.field_content_mandarin?.data?.nextPage?.link) || "";
        }
      })(),
    },
    fields: fields?.nextPageOurPolicies,
  };

  // const NextPageFormConfig: FormConfig = {
  //   initialValues: {
  //     [`field_content_english.data.nextPage.name`]:
  //       airportsDataById?.payload
  //         ? decodeHTML(airportsDataById?.payload?.field_content_english?.data?.nextPage?.name)
  //         : decodeHTML(airportsData?.[0]?.field_content_english?.data?.nextPage?.name),

  //     [`field_content_english.data.nextPage.link`]:
  //         airportsDataById?.payload
  //           ? decodeHTML(airportsDataById?.payload?.field_content_english?.data?.nextPage?.link)
  //           : decodeHTML(airportsData?.[0]?.field_content_english?.data?.nextPage?.link),
  //     [`field_content_malay.data.nextPage.name`]:
  //         airportsDataById?.payload
  //           ? decodeHTML(airportsDataById?.payload?.field_content_malay?.data?.nextPage?.name)
  //           : decodeHTML(airportsData?.[0]?.field_content_malay?.data?.nextPage?.name),
  //     [`field_content_malay.data.nextPage.link`]:
  //         airportsDataById?.payload
  //           ? decodeHTML(airportsDataById?.payload?.field_content_malay?.data?.nextPage?.link)
  //           : decodeHTML(airportsData?.[0]?.field_content_malay?.data?.nextPage?.link),
  //     [`field_content_mandarin.data.nextPage.name`]:
  //           airportsDataById?.payload
  //             ? decodeHTML(airportsDataById?.payload?.field_content_mandarin?.data?.nextPage?.name)
  //             : decodeHTML(airportsData?.[0]?.field_content_mandarin?.data?.nextPage?.name),
  //     [`field_content_mandarin.data.nextPage.link`]:
  //           airportsDataById?.payload
  //             ? decodeHTML(airportsDataById?.payload?.field_content_mandarin?.data?.nextPage?.link)
  //             : decodeHTML(airportsData?.[0]?.field_content_mandarin?.data?.nextPage?.link),
  //   },
  //   fields: fields?.nextPageOurPolicies,
  // };

  const createFormConfig = (name: string, fieldName: any, idx1: any, idx2: any): FormConfig => {
    const getImageUrl = (language: Language) => {
      const payload = airportsDataById?.payload?.[language];
      if (!isLoadingairportsById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML([
              {
                uid: "-1",
                name: "field_content_english_image.png",
                status: "done",
                url:
                  JSON.parse(payload)?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.image?.[0]?.url ||
                  JSON.parse(payload)?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.image,
              },
            ]);
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML([
            {
              uid: "-1",
              name: "field_content_english_image.png",
              status: "done",
              url:
                payload?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.image?.[0]?.url ||
                payload?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.image,
            },
          ]);
        }
      }
      return decodeHTML([
        {
          uid: "-1",
          name: "field_content_english_image.png",
          status: "done",
          url: airportsData?.[0]?.[language]?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.image || "",
        },
      ]);
    };

    const getMetricValue = (language: Language, metric: MetricKey) => {
      const payload = airportsDataById?.payload?.[language];
      if (!isLoadingairportsById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(
              JSON.parse(payload)?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.metrics?.[metric] || ""
            );
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.metrics?.[metric] || "");
        }
      }
      return decodeHTML(
        airportsData?.[0]?.[language]?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.metrics?.[metric] || ""
      );
    };

    const getDescriptionValue = (language: Language) => {
      const payload = airportsDataById?.payload?.[language];
      if (!isLoadingairportsById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.descriptions || "");
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.descriptions || "");
        }
      }
      return decodeHTML(airportsData?.[0]?.[language]?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.descriptions || "");
    };
    const getTitleValue = (language: Language) => {
      const payload = airportsDataById?.payload?.[language];
      if (!isLoadingairportsById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.title || "");
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.title || "");
        }
      }
      return decodeHTML(airportsData?.[0]?.[language]?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.title || "");
    };

    const getKeyValue = (language: Language) => {
      const payload = airportsDataById?.payload?.[language];
      if (!isLoadingairportsById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.key || "");
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.key || "");
        }
      }
      return decodeHTML(airportsData?.[0]?.[language]?.data?.items?.[idx1]?.tabData?.items?.[idx2]?.key || "");
    };

    const getNextPageValue = (language: Language, key: NextPageKey) => {
      const payload = airportsDataById?.payload?.[language];
      if (!isLoadingairportsById) {
        if (typeof payload === "string") {
          try {
            return decodeHTML(JSON.parse(payload)?.data?.nextPage?.[key] || "");
          } catch (error) {
            return "";
          }
        } else if (typeof payload === "object") {
          return decodeHTML(payload?.data?.nextPage?.[key] || "");
        }
      }
      return decodeHTML(airportsData?.[0]?.[language]?.data?.nextPage?.[key] || "");
    };

    const iataicaoKey = name === "istanbul-sabiha-gokcen-airport" ? "IATA:SAW, ICAO LTFJ" : "IATA/ICAO code";

    const iataicaolabel = name === "istanbul-sabiha-gokcen-airport" ? "IATA/SAW ICAO LTFJ" : "IATA/ICAO code";

    return {
      initialValues: {
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].title`]:
          getTitleValue("field_content_english"),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].key`]: getKeyValue("field_content_english"),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].image`]:
          getImageUrl("field_content_english"),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].metrics.${iataicaolabel}`]: getMetricValue(
          "field_content_english",
          iataicaoKey
        ),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].metrics.Latitude`]: getMetricValue(
          "field_content_english",
          "Latitude"
        ),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].metrics.Elevation`]: getMetricValue(
          "field_content_english",
          "Elevation"
        ),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].metrics.Longitude`]: getMetricValue(
          "field_content_english",
          "Longitude"
        ),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].metrics.Runway`]: getMetricValue(
          "field_content_english",
          "Runway"
        ),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].metrics.Capacity`]: getMetricValue(
          "field_content_english",
          "Capacity"
        ),
        [`field_content_english.data.items[${idx1}].tabData.items[${idx2}].descriptions`]:
          getDescriptionValue("field_content_english"),
        // [`field_content_english_nextPage_name`]: getNextPageValue("field_content_english", "name"),
        // [`field_content_english_nextPage_link`]: getNextPageValue("field_content_english", "link"),

        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].title`]: getTitleValue("field_content_malay"),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].key`]: getKeyValue("field_content_malay"),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].image`]: getImageUrl("field_content_malay"),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].metrics.${iataicaolabel}`]: getMetricValue(
          "field_content_malay",
          iataicaoKey
        ),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].metrics.Latitude`]: getMetricValue(
          "field_content_malay",
          "Latitude"
        ),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].metrics.Elevation`]: getMetricValue(
          "field_content_malay",
          "Elevation"
        ),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].metrics.Longitude`]: getMetricValue(
          "field_content_malay",
          "Longitude"
        ),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].metrics.Runway`]: getMetricValue(
          "field_content_malay",
          "Runway"
        ),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].metrics.Capacity`]: getMetricValue(
          "field_content_malay",
          "Capacity"
        ),
        [`field_content_malay.data.items[${idx1}].tabData.items[${idx2}].descriptions`]:
          getDescriptionValue("field_content_malay"),
        // [`field_content_malay_nextPage_name`]: getNextPageValue("field_content_malay", "name"),
        // [`field_content_malay_nextPage_link`]: getNextPageValue("field_content_malay", "link"),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].title`]:
          getTitleValue("field_content_mandarin"),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].key`]:
          getKeyValue("field_content_mandarin"),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].image`]:
          getImageUrl("field_content_mandarin"),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].metrics.${iataicaolabel}`]: getMetricValue(
          "field_content_mandarin",
          iataicaoKey
        ),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].metrics.Latitude`]: getMetricValue(
          "field_content_mandarin",
          "Latitude"
        ),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].metrics.Elevation`]: getMetricValue(
          "field_content_mandarin",
          "Elevation"
        ),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].metrics.Longitude`]: getMetricValue(
          "field_content_mandarin",
          "Longitude"
        ),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].metrics.Runway`]: getMetricValue(
          "field_content_mandarin",
          "Runway"
        ),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].metrics.Capacity`]: getMetricValue(
          "field_content_mandarin",
          "Capacity"
        ),
        [`field_content_mandarin.data.items[${idx1}].tabData.items[${idx2}].descriptions`]:
          getDescriptionValue("field_content_mandarin"),
        // [`field_content_mandarin_nextPage_name`]: getNextPageValue("field_content_mandarin", "name"),
        // [`field_content_mandarin_nextPage_link`]: getNextPageValue("field_content_mandarin", "link"),
      },
      fields: fieldName,
    };
    // return {
    //   initialValues: {
    //     [`field_content_english_imageFor${name}`]: "",
    //     [`field_content_english_iataicaocodeFor${name}`]: "",
    //     [`field_content_english_latitudeFor${name}`]: "",
    //     [`field_content_english_elevationFor${name}`]: "",
    //     [`field_content_english_longitudeFor${name}`]: "",
    //     [`field_content_english_runwayFor${name}`]: "",
    //     [`field_content_english_capacityFor${name}`]: "",
    //     [`field_content_english_descriptionsFor${name}`]: "",
    //     [`field_content_english_nextPage_name`]: "",
    //     [`field_content_english_nextPage_link`]: "",

    //     [`field_content_malay_imageFor${name}`]: "",
    //     [`field_content_malay_iataicaocodeFor${name}`]: "",
    //     [`field_content_malay_latitudeFor${name}`]: "",
    //     [`field_content_malay_elevationFor${name}`]: "",
    //     [`field_content_malay_longitudeFor${name}`]: "",
    //     [`field_content_malay_runwayFor${name}`]: "",
    //     [`field_content_malay_capacityFor${name}`]: "",
    //     [`field_content_malay_descriptionsFor${name}`]: "",
    //     [`field_content_malay_nextPage_name`]: "",
    //     [`field_content_malay_nextPage_link`]: "",

    //     [`field_content_mandarin_imageFor${name}`]: "",
    //     [`field_content_mandarin_iataicaocodeFor${name}`]: "",
    //     [`field_content_mandarin_latitudeFor${name}`]: "",
    //     [`field_content_mandarin_elevationFor${name}`]: "",
    //     [`field_content_mandarin_longitudeFor${name}`]: "",
    //     [`field_content_mandarin_runwayFor${name}`]: "",
    //     [`field_content_mandarin_capacityFor${name}`]: "",
    //     [`field_content_mandarin_descriptionsFor${name}`]: "",
    //     [`field_content_mandarin_nextPage_name`]: "",
    //     [`field_content_mandarin_nextPage_link`]: "",
    //   },
    //   fields: fieldName,
    // };
  };
  const showToast = (content: string, type: "success" | "error") => {
    openToast({
      content,
      type,
    });
  };

  const updateDocument = async (payload: any, status: "DRAFT" | "PENDING") => {
    try {
      const response: any = await put(`/management/update-document?approvalId=${query.get("id")}`, payload);
      showToast(status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully", "success");
      if (response.status === "OK" && status == "PENDING") {
        navigate("/dedicated/status-information?activeTab=pending");
      } else {
        navigate("/dedicated/status-information?activeTab=draft");
      }
    } catch (err: any) {
      showToast("Failed to save data", "error");
    }
  };

  const publishDocument = async (payload: any, status: "DRAFT" | "PENDING") => {
    try {
      const response: any = await post("/management/publish", payload);
      showToast(status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review", "success");
      if (response.status === "OK" && status == "PENDING") {
        navigate("/dedicated/status-information?activeTab=pending");
      } else {
        navigate("/dedicated/status-information?activeTab=draft");
      }
    } catch (err: any) {
      showToast("Failed to save data", "error");
    }
  };

  const updatePayload = async (data: any) => {
    console.log("updatePayload-1", data, payloadData, airportsData, airportsDataById);

    const parseIfJson = (value: any) => {
      if (typeof value === "string") {
        try {
          return JSON.parse(value);
        } catch {
          return value; // Return as is if not valid JSON
        }
      }
      return value;
    };

    const parsedPayloadData = { ...payloadData };
    ["field_content_english", "field_content_malay", "field_content_mandarin"].forEach((field) => {
      if (parsedPayloadData[field]) {
        parsedPayloadData[field] = parseIfJson(parsedPayloadData[field]);
      }
    });

    const convertedData = convertDotNotation(data);
    const filteredData = filterNestedObjects(convertedData);

    console.log("updatePayload-2", filteredData);

    const payload = { ...parsedPayloadData };
    console.log("existing payload", payload, payloadData);

    // Define keys that might contain image data
    const dynamicImageKeys: string[] = ["image"];

    // Process images in the filteredData
    const processImageFields = async (obj: any) => {
      for (const key of dynamicImageKeys) {
        if (obj[key] && Array.isArray(obj[key]) && obj[key].length > 0) {
          const fileObj = obj[key][0];
          try {
            if (fileObj.originFileObj) {
              console.log("Uploading new image:", fileObj.originFileObj);
              const formData = new FormData();
              formData.append("upload-file", fileObj.originFileObj);
              formData.append("application", "CORPORATE");

              const res: any = await post("management/upload-file", formData);
              if (res && res.response?.data) {
                obj[key] = res.response.data; // Replace array with URL
                console.log("Upload successful, URL:", res.response.data);
              }
            } else if (fileObj.url) {
              obj[key] = fileObj.url; // Use existing URL
              console.log("Using existing image URL:", fileObj.url);
            }
          } catch (error) {
            console.error(`Error processing ${key}:`, error);
          }
        }
      }
    };

    if (filteredData.field_content_english?.data?.items) {
      for (const item of filteredData.field_content_english.data.items) {
        if (!item) {
          console.log("Skipping null or undefined item");
          continue;
        }
        if (item.tabData?.items && Array.isArray(item.tabData.items)) {
          for (const tabItem of item.tabData.items) {
            if (tabItem) {
              await processImageFields(tabItem); // Process images in tabItem
            }
          }
        }
      }
    }
    if (filteredData.field_content_english?.data?.items) {
      const englishItems = filteredData.field_content_english.data.items;
      ["field_content_malay", "field_content_mandarin"].forEach((lang) => {
        if (filteredData[lang]?.data?.items) {
          filteredData[lang].data.items.forEach((item: any, index: number) => {
            if (item?.tabData?.items && englishItems[index]?.tabData?.items) {
              item.tabData.items.forEach((tabItem: any, tabIndex: number) => {
                if (englishItems[index]?.tabData?.items[tabIndex]?.image) {
                  tabItem.image = englishItems[index].tabData.items[tabIndex].image;
                }
              });
            }
          });
        }
      });
    }

    console.log("updatePayload-f2", payload, filteredData);
    replacePayload(payload, filteredData);

    console.log("updatePayload-3", payload);

    // ==================== KEY RESTORATION LOGIC ====================
    console.log("Before key restoration:", JSON.parse(JSON.stringify(payload)));

    // Restore special airport keys (especially IATA/ICAO keys)
    const restoreSpecialMetricKeys = (obj: any) => {
      if (!obj || typeof obj !== "object") return;

      const badKey = "IATA/SAW ICAO LTFJ";
      const correctKey = "IATA:SAW, ICAO LTFJ";

      if (obj.metrics && typeof obj.metrics === "object") {
        if (obj.metrics[badKey] !== undefined) {
          obj.metrics[correctKey] = obj.metrics[badKey];
          delete obj.metrics[badKey];
          console.log(`✅ Restored key: ${badKey} → ${correctKey}`);
        }
      }

      // Recurse into nested objects
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === "object" && obj[key] !== null) {
          restoreSpecialMetricKeys(obj[key]);
        }
      });
    };

    // Apply restoration to all languages
    const contentFields = ["field_content_english", "field_content_malay", "field_content_mandarin"];
    contentFields.forEach((field) => {
      if (payload[field]?.data?.items) {
        payload[field].data.items.forEach((item: any) => {
          if (item?.tabData?.items) {
            item.tabData.items.forEach((tabItem: any) => {
              restoreSpecialMetricKeys(tabItem);
            });
          }
        });
      }
    });

    console.log("After key restoration:", JSON.parse(JSON.stringify(payload)));
    // ============================================================

    console.log("updatePayload-4", payload);

    // Stringify content fields before sending
    contentFields.forEach((field) => {
      if (payload[field]) {
        payload[field] = JSON.stringify(payload[field]);
      }
    });

    return payload;
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    const payloadValue = await updatePayload(data);
    const activeTab = query?.get("activeTab") || "ourAirports";
    const subActiveTab = query?.get("subActiveTab") || "";
    const thirdSubActiveTab = query?.get("thirdSubActiveTab") || "";

    let computedSubModule = `${activeTab}_${subActiveTab}${thirdSubActiveTab ? `_${thirdSubActiveTab}` : ""}`;

    if (thirdSubActiveTab && subActiveTab && thirdSubActiveTab !== "nextPage") {
      try {
        const match = thirdSubActiveTab.match(/For(International|Domestic|Stolports|Overseas)_(\d+)$/);
        const idx1 = match ? parseInt(match[2], 10) : undefined;
        const tabType = match ? match[1] : undefined;

        const englishJson = payloadData?.field_content_english
          ? JSON.parse(payloadData.field_content_english)
          : undefined;

        const tabIndexMap: { [key: string]: number } = {
          international: 0,
          domestic: 1,
          stolports: 2,
          overseas: 3,
        };
        const tabIndex = tabIndexMap[subActiveTab.toLowerCase()];

        const currentIndex = englishJson?.data?.items?.[tabIndex]?.tabData?.items?.[idx1 || 0]?.key;

        if (currentIndex && tabType) {
          computedSubModule = `${activeTab}_${subActiveTab}_${toCamelCase(currentIndex)}For${tabType}_${idx1}`;
        }
      } catch (e) {
        console.error("Error computing subModule:", e);
        computedSubModule = `${activeTab}_${subActiveTab}_${thirdSubActiveTab}`;
      }
    } else if (subActiveTab === "nextPage") {
      computedSubModule = `${activeTab}_nextPage`;
    }
    const payload = {
      action: action,
      method: method,
      module: "CorporateProfile",
      subModule: computedSubModule, //`${query?.get("activeTab")}_${query?.get("subActiveTab")}${query?.get("thirdSubActiveTab") ? `_${query.get("thirdSubActiveTab")}` : ''}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      moduleKey: "MAHB_CORPORATE_Corporate Profile_Our Airports",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      payload: payloadValue,
      status: status,
    };
    if (query.get("id")) {
      await updateDocument(payload, status);
    } else {
      await publishDocument(payload, status);
    }
  };

  const generateFormItem = (label: any, key: any, config: any, API_ENDPOINT: any) => {
    return {
      label,
      key,
      children: (
        <DynamicForm
          isLoading={isLoadingairports || isLoadingairportsById}
          config={config}
          onSubmit={(data, buttonValue, reviewNotes) =>
            onSubmit(data, API_ENDPOINT, "UPDATE", "PATCH", buttonValue === "save" ? "DRAFT" : "PENDING", reviewNotes)
          }
          defaultReviewNotes="Kindly review this Corporate Profile"
        />
      ),
    };
  };

  const airportSubChildItems1 = airportsData
    ? airportsData?.[0]?.field_content_english?.data?.items[0]?.tabData?.items
        .filter(Boolean)
        .map((item: any, index: any) => {
          const uniqueKey = `${toCamelCase(item.key)}ForInternational_${index}`;
          const pascalCaseConfigName = `${toPascalCase(item.key)}ForInternationalFormConfig`;

          return generateFormItem(
            item.title,
            uniqueKey,
            createFormConfig(item.key, fieldData?.internationalOurAirports?.[index], [0], [index]),
            `${corporateHost}/api/page-content/${airportsData?.[0]?.id || airportsDataById?.payload?.id || "66"}`
          );
        })
    : (() => {
        const fieldContent = airportsDataById?.payload?.field_content_english;
        let parsedContent;

        // Validate and safely parse JSON
        try {
          parsedContent = fieldContent ? JSON.parse(fieldContent) : null;
        } catch (error) {
          console.error("Failed to parse field_content_english:", error);
          parsedContent = null;
        }
        console.log("tabDataforid", parsedContent?.data?.items[0]?.tabData?.items);
        return (
          parsedContent?.data?.items[0]?.tabData?.items?.filter(Boolean)?.map((item: any, index: any) => {
            const uniqueKey = `${toCamelCase(item.key)}ForInternational_${index}`;
            const pascalCaseConfigName = `${toPascalCase(item.key)}ForInternationalFormConfig`;
            console.log(
              "tabDataforid -1",
              createFormConfig(item.key, fieldData?.internationalOurAirports?.[index], [0], [index])
            );
            return generateFormItem(
              item.title,
              uniqueKey,
              createFormConfig(item.key, fieldData?.internationalOurAirports?.[index], [0], [index]),
              `${corporateHost}/api/page-content/${airportsData?.[0]?.id || airportsDataById?.payload?.id || "66"}`
            );
          }) || []
        );
      })();

  const airportSubChildItems2 = airportsData
    ? airportsData?.[0]?.field_content_english?.data?.items[1]?.tabData?.items
        .filter(Boolean)
        .map((item: any, index: any) => {
          const uniqueKey = `${toCamelCase(item.key)}ForDomestic_${index}`;
          const pascalCaseConfigName = `${toPascalCase(item.key)}ForDomestic`;

          return generateFormItem(
            item.title,
            uniqueKey,
            createFormConfig(item.key, fieldData?.domesticOurAirports?.[index], [1], [index]),
            `${corporateHost}/api/page-content/${airportsData?.[0]?.id || airportsDataById?.payload?.id || "66"}`
          );
        })
    : (() => {
        const fieldContent = airportsDataById?.payload?.field_content_english;
        let parsedContent;

        // Validate and safely parse JSON
        try {
          parsedContent = fieldContent ? JSON.parse(fieldContent) : null;
        } catch (error) {
          console.error("Failed to parse field_content_english:", error);
          parsedContent = null;
        }

        return (
          parsedContent?.data?.items[1]?.tabData?.items?.filter(Boolean)?.map((item: any, index: any) => {
            const uniqueKey = `${toCamelCase(item.key)}ForDomestic_${index}`;
            const pascalCaseConfigName = `${toPascalCase(item.key)}ForDomestic`;

            return generateFormItem(
              item.title,
              uniqueKey,
              createFormConfig(item.key, fieldData?.domesticOurAirports?.[index], [1], [index]),
              `${corporateHost}/api/page-content/${airportsData?.[0]?.id || airportsDataById?.payload?.id || "66"}`
            );
          }) || []
        );
      })();

  const airportSubChildItems3 = airportsData
    ? airportsData?.[0]?.field_content_english?.data?.items[2]?.tabData?.items
        .filter(Boolean)
        .map((item: any, index: any) => {
          const uniqueKey = `${toCamelCase(item.key)}ForStolports_${index}`;
          const pascalCaseConfigName = `${toPascalCase(item.key)}ForStolportsFormConfig`;

          return generateFormItem(
            item.title,
            uniqueKey,
            createFormConfig(item.key, fieldData?.stolportsOurAirports?.[index], [2], [index]),
            `${corporateHost}/api/page-content/${airportsData?.[0]?.id || airportsDataById?.payload?.id || "66"}`
          );
        })
    : (() => {
        const fieldContent = airportsDataById?.payload?.field_content_english;
        let parsedContent;

        // Validate and safely parse JSON
        try {
          parsedContent = fieldContent ? JSON.parse(fieldContent) : null;
        } catch (error) {
          console.error("Failed to parse field_content_english:", error);
          parsedContent = null;
        }

        return (
          parsedContent?.data?.items[2]?.tabData?.items?.filter(Boolean)?.map((item: any, index: any) => {
            const uniqueKey = `${toCamelCase(item.key)}ForStolports_${index}`;
            const pascalCaseConfigName = `${toPascalCase(item.key)}ForStolportsFormConfig`;

            return generateFormItem(
              item.title,
              uniqueKey,
              createFormConfig(item.key, fieldData?.stolportsOurAirports?.[index], [2], [index]),
              `${corporateHost}/api/page-content/${airportsData?.[0]?.id || airportsDataById?.payload?.id || "66"}`
            );
          }) || []
        );
      })();

  const airportSubChildItems4 = airportsData
    ? airportsData?.[0]?.field_content_english?.data?.items[3]?.tabData?.items
        .filter(Boolean)
        .map((item: any, index: any) => {
          const uniqueKey = `${toCamelCase(item.key)}ForOverseas_${index}`;
          const pascalCaseConfigName = `${toPascalCase(item.key)}ForOverseas`;

          return generateFormItem(
            item.title,
            uniqueKey,
            createFormConfig(item.key, fieldData?.overseasOurAirports?.[index], [3], [index]),
            `${corporateHost}/api/page-content/${airportsData?.[0]?.id || airportsDataById?.payload?.id || "66"}`
          );
        })
    : (() => {
        const fieldContent = airportsDataById?.payload?.field_content_english;
        let parsedContent;

        // Validate and safely parse JSON
        try {
          parsedContent = fieldContent ? JSON.parse(fieldContent) : null;
        } catch (error) {
          console.error("Failed to parse field_content_english:", error);
          parsedContent = null;
        }

        return (
          parsedContent?.data?.items[3]?.tabData?.items?.filter(Boolean)?.map((item: any, index: any) => {
            const uniqueKey = `${toCamelCase(item.key)}ForOverseas_${index}`;
            const pascalCaseConfigName = `${toPascalCase(item.key)}ForOverseas`;

            return generateFormItem(
              item.title,
              uniqueKey,
              createFormConfig(item.key, fieldData?.overseasOurAirports?.[index], [3], [index]),
              `${corporateHost}/api/page-content/${airportsData?.[0]?.id || airportsDataById?.payload?.id || "66"}`
            );
          }) || []
        );
      })();

  const generateAirportsTabItem = (label: any, key: any, subChildItems: any) => ({
    label,
    key,
    children: (
      <Tabs
        activeKey={query?.get("thirdSubActiveTab") || ""}
        items={subChildItems}
        onChange={(activeKey) => {
          navigate(
            `${window.location.pathname}?activeTab=ourAirports&subActiveTab=${key}&thirdSubActiveTab=${activeKey}`
          );
        }}
      ></Tabs>
    ),
  });

  const airportChildItems = [
    {
      label: "Page Heading",
      key: "ourAirportsPageHeading",
      children: <OurAirportsPageHeading />,
    },
    generateAirportsTabItem("International", "international", airportSubChildItems1),
    generateAirportsTabItem("Domestic", "domestic", airportSubChildItems2),
    generateAirportsTabItem("STOLports", "stolports", airportSubChildItems3),
    generateAirportsTabItem("Overseas", "overseas", airportSubChildItems4),
    generateFormItem(
      "Next Page",
      "nextPage",
      NextPageFormConfig,
      `${corporateHost}/api/page-content/${airportsData?.[0]?.id || airportsDataById?.payload?.id || "66"}`
    ),
  ];

  if (isLoadingairports || isLoadingairportsById) {
    return <Loader />;
  }

  return (
    <Tabs
      activeKey={query?.get("subActiveTab") || ""}
      items={airportChildItems}
      onChange={(activeKey) => {
        navigate(`${window.location.pathname}?activeTab=ourAirports&subActiveTab=${activeKey}`);
      }}
    ></Tabs>
  );
};
